import React from 'react';
import { View, Text, Platform, Dimensions, TouchableOpacity } from 'react-native';
import Alert from './Alert';
import CS from '../constants/Styles';
import Colors from '../constants/Colors';
import { AntDesign } from '@expo/vector-icons';
import Tooltip from './ToolTip';

export default function ToolTipWrapper(props) {
  const [alertOptions, setAlertOptions] = React.useState({});

  const windowWidth = Dimensions.get('window').width;

  const showWebToolTip = () => {
    setAlertOptions({
      visible: true,
      // message: props.text.join(' '),
      message: props.text,
      isToolTip: true,
    });
  }

  const innerContent = () => {
    if (Platform.OS === 'web') {
      return (
        <TouchableOpacity activeOpacity={0.6} onPress={() => showWebToolTip('Project Documents')}>
          <AntDesign name="questioncircle" size={24} color={Colors.lightBlue2} style={{ marginLeft: 5 }} />
        </TouchableOpacity>
      )
    }
    return (
      <Tooltip
        popover={<View>{props.text.map((p, i) => { return (<Text style={[CS.smallText, CS.lightBlueText, { marginBottom: i + 1 !== props.text.length ? 10 : 0, }]} key={i}>{p}</Text>); })}</View>}
        backgroundColor={Colors.blue}
        height='auto'
        width={windowWidth > 768 ? 748 : windowWidth - 20}
        overlayColor='rgba(0,0,0,0.75)'
      >
        <AntDesign name="questioncircle" size={24} color={Colors.lightBlue2} style={{ marginLeft: 5 }} />
      </Tooltip>
    )
  }

  return (
    <>
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      {innerContent()}
    </>
  );
}